import { render, staticRenderFns } from "./PartnerSubscriptionTermsDetail.vue?vue&type=template&id=02e48d4a&scoped=true&"
import script from "./PartnerSubscriptionTermsDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerSubscriptionTermsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e48d4a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/partner/sections/details/PartnerSubscriptionTermsDetail.vue
// module id = 667
// module chunks = 0